import { render, staticRenderFns } from "./FormChofer.vue?vue&type=template&id=74740995&"
import script from "./FormChofer.vue?vue&type=script&lang=js&"
export * from "./FormChofer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports